import type { AvailableMailingProductsDto } from '@/services/ws-post/src/main/resources/rest-api';
import { MailingProduct, MailingType } from '@/services/ws-post/src/main/resources/rest-api';

import { filterHolidayDays, isWeekday } from './helpers';

export const DEFAULT_MAILING_PRODUCTS_WITHOUT_FLAP: MailingProduct[] = Object.values(MailingProduct).filter(
  (product) => product !== MailingProduct.FLAP,
);

export const isFlapProduct = (product: MailingProduct | undefined): boolean => product === MailingProduct.FLAP;

export const shouldDisableOfficialMailingType = (product: MailingProduct | undefined): boolean => isFlapProduct(product);

export const getProductsForMailingType = (
  available: AvailableMailingProductsDto | undefined,
  mailingType: MailingType | undefined,
): MailingProduct[] => {
  if (!available) {
    return DEFAULT_MAILING_PRODUCTS_WITHOUT_FLAP;
  }

  if (mailingType === MailingType.OFFICIAL) {
    return available.officialProducts;
  }

  return available.commercialProducts;
};

export const isFlapDistributionDateAllowed = (date: Date): boolean => {
  const day = date.getDay();

  return day === 2 || day === 3;
};

export const filterDistributionDateForProduct = (product: MailingProduct | undefined, date: Date): boolean => {
  if (!filterHolidayDays(date)) {
    return false;
  }

  if (isFlapProduct(product)) {
    return isFlapDistributionDateAllowed(date);
  }

  return isWeekday(date);
};

export const isDistributionDateValidForProduct = (product: MailingProduct | undefined, date: Date): boolean =>
  filterDistributionDateForProduct(product, date);
